import { Icons } from "../../../assets/icons/Icons";

const RecentActivity = ({ recentActivity }) => {
    return (
        <div
            className="card mb-4"
            style={{
                border: "1px solid rgba(78, 78, 255, 0.3)",
                borderRadius: "20px",
                backgroundColor: "rgba(18, 18, 30, 0.8)",
            }}
        >
            <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="text-white fs-5 m-0">Recent Activity</h3>
                    <Icons.RoundKabebIcon />
                </div>

                <div className="table-responsive">
                    <table className="table table-dark table-borderless mb-0">
                        <thead>
                            <tr className="text-secondary">
                                <th className="investment-th">Date</th>
                                <th className="investment-th">Type</th>
                                <th className="investment-th">Amount</th>
                                <th className="investment-th text-end">
                                    Status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {recentActivity.map((activity, index) => (
                                <tr key={index} className="text-white">
                                    <td className="ps-0 py-3 investment-td">
                                        {activity.date}
                                    </td>
                                    <td className="py-3 investment-td">
                                        {activity.type}
                                    </td>
                                    <td className="py-3 investment-td">
                                        ${activity.amount}
                                    </td>
                                    <td className="text-end py-3 investment-td">
                                        <span
                                            className="badge rounded-pill px-2 py-1"
                                            style={{
                                                backgroundColor:
                                                    activity.status ===
                                                    "Completed"
                                                        ? "#4ECCA3"
                                                        : "#B8860B",
                                                color: "white",
                                                fontSize: "0.85rem",
                                                fontWeight: "normal",
                                            }}
                                        >
                                            {activity.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RecentActivity;
